import {useQuery} from '@tanstack/react-query'
import {useContentstack} from '../../context/contentstack'
import {getEntry} from '../api/contentstack/sdk/entry'
import useMultiSite from '@salesforce/retail-react-app/app/hooks/use-multi-site'
import {BRAND_KEY} from '../../brand'

/**
 * Hook to fetch all footer entries from contentstack
 */

let prefix = ''
if (BRAND_KEY === 'kenwood' || BRAND_KEY === 'braun') prefix = `${BRAND_KEY}_`

// export const useGetFooter = () => {
//     const {stack} = useContentstack()
//     const {locale} = useMultiSite()

//     const getFooterRes = async () => {
//         const response = await getEntryByTitle({
//             stack,
//             contentTypeUid: `${prefix}footer`,
//             title: 'FooterGroup',
//             referenceFieldPath: ['footer_content.footer_reference_components'],
//             locale: locale.alias,
//         })
//         return response[0]
//     }

//     return useQuery(['contentstackGetFooter', 'footer'], () => getFooterRes())
// }

export const useGetFooterByContentType = () => {
    const {stack} = useContentstack()
    const {locale} = useMultiSite()

    const getFooterByContentType = async () => {
        const res = await getEntry({
            stack,
            contentTypeUid: `${prefix}footer`,
            referenceFieldPath: ['footer_content.footer_reference_components'],
            locale: locale.alias,
        })
        return res[0]
    }

    return useQuery(['contentstackGetFooterByContentType', 'footer'], () =>
        getFooterByContentType(),
    )
}
